import Section from '@components/common/Section/Section'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import React, { FC } from 'react'
import { MediaPicker } from 'types/mediaPicker'
import styles from './UPSBanner.module.scss'

type UPSElement = {
  richText: string
  icon: MediaPicker
}
type EcommerceUpsProps = {
  upsElements?: UPSElement[]
  backgroundColor?: string
}

const UPSBanner: FC<EcommerceUpsProps> = ({ upsElements, backgroundColor }) => {
  return (
    <Section
      className={'container'}
      style={{ backgroundColor: backgroundColor }}
    >
      <ul className="flex justify-around flex-wrap sm:flex-nowrap">
        {upsElements &&
          upsElements.map((upsElement) => (
            <li
              key={upsElement.richText}
              style={
                {
                  '--desktop-width': `${100 / upsElements.length}%`,
                } as React.CSSProperties
              }
              className={styles.richText}
            >
              <div className={styles.upsElement}>
                {upsElement.icon && <img src={upsElement.icon.url} />}
                <TrustedHtml html={upsElement.richText} className="" />
              </div>
            </li>
          ))}
      </ul>
    </Section>
  )
}

export default UPSBanner
